"use client";
import {NeoBreadcrumb, NeoCard} from "@/components/shared";
import {useNeoContext} from "@/context/neo/neo.context";
import {decryptUrl} from "@/libs/helper";
import {userService} from "@/service/users.service";
import {CardBody, Spinner} from "@nextui-org/react";
import {useEffect, useState} from "react";
import {ViewUser} from "./view-user";

const sKey: string = process.env.NEXT_PUBLIC_NEO_SECRET || "";

interface PageProps {
  id: number | string;
  action: string;
  slug: string;
}

interface ViewUserPageProps {
  params: PageProps;
}

const breadCrumb = [
  {
    link: "/users",
    label: "User"
  },
  {
    link: "",
    label: "User Details"
  }
];

export const ViewUserPage: React.FC<ViewUserPageProps> = function ({params}) {
  const {filterContext} = useNeoContext();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<any>(null);

  const fetchData = async () => {
    setLoading(true);
    const id = await decryptUrl(params.id as string, sKey);
    // reuse the same fetch used by the user edit flow to populate
    // the User Details / Vehicle Mapping Details view
    await userService
      .onFetchUserDetails(id as string, "edit", "user")
      .then((response: any) => {
        setData(response);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (filterContext?.client?.institutionId) {
      fetchData();
    }
  }, [params, filterContext?.client?.institutionId]);

  return (
    <div className="flex min-h-[calc(100vh-63px)] w-full flex-col p-5">
      <div className="mb-5 flex-row">
        <NeoBreadcrumb menus={breadCrumb}></NeoBreadcrumb>
      </div>
      <div className="w-full flex-row">
        <NeoCard className="mb-5 bg-transparent shadow-none">
          {loading ? (
            <CardBody>
              <Spinner color="default" />
            </CardBody>
          ) : (
            <ViewUser
              client={filterContext?.client}
              header="User"
              items={data}
              onRefresh={fetchData}
            />
          )}
        </NeoCard>
      </div>
    </div>
  );
};
